export const loadState = (key: string) => {
    try {
      const serializedState = localStorage.getItem(key);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  };
  export const loadSessionState = (key: string) => {
    try {
      const serializedState = sessionStorage.getItem(key);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  };
  
  export const saveState = (key: string, value: unknown) => {
    try {
      const serializedState = JSON.stringify(value);
      localStorage.setItem(key, serializedState);
    } catch {
    }
  };
  export const saveSessionState = (key: string, value: unknown) => {
    try {
      const serializedState = JSON.stringify(value);
      sessionStorage.setItem(key, serializedState);
    } catch {
    }
  };
  
  export const clearSession = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
    }
  };
  
  export const clearSessionKey = (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch {
    }
  }
  